import axios from 'axios'
import React from 'react'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { getOrgMembers } from 'src/app/PeopleMembers/redux/peopleMembers.actions'
import { createSetIsToastOpen } from 'src/app/Toast/redux/toast.actions'
import { RemoveUserFromOrganizationToastMessage } from 'src/app/Toast/Toast'
import { UserListResponse } from 'src/models/user.models'
import { closeModal } from 'src/navigation/Lnk'
import { RootState } from 'src/redux/createRootReducer'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'
import { BackendErrorPayload } from 'src/utils/error.utils'

export const REMOVE_USER_FROM_ORGANIZATION_INIT_ACTION =
  'data/people/REMOVE_USER_FROM_ORGANIZATION_INIT_ACTION'
export const REMOVE_USER_FROM_ORGANIZATION_SUCCESS_ACTION =
  'data/people/REMOVE_USER_FROM_ORGANIZATION_SUCCESS_ACTION'
export const REMOVE_USER_FROM_ORGANIZATION_FAILURE_ACTION =
  'data/people/REMOVE_USER_FROM_ORGANIZATION_FAILURE_ACTION'

export type RemoveUserFromOrganizationSuccessPayload = {
  user: UserListResponse
}

export type RemoveUserFromOrganizationErrorPayload = BackendErrorPayload<string>

export interface RemoveUserFromOrganizationInitAction {
  type: typeof REMOVE_USER_FROM_ORGANIZATION_INIT_ACTION
}
export interface RemoveUserFromOrganizationSuccessAction {
  type: typeof REMOVE_USER_FROM_ORGANIZATION_SUCCESS_ACTION
  payload: RemoveUserFromOrganizationSuccessPayload
}
export interface RemoveUserFromOrganizationFailureAction {
  type: typeof REMOVE_USER_FROM_ORGANIZATION_FAILURE_ACTION
  payload: RemoveUserFromOrganizationErrorPayload
}

export type RemoveUserFromOrganizationActions =
  | RemoveUserFromOrganizationInitAction
  | RemoveUserFromOrganizationSuccessAction
  | RemoveUserFromOrganizationFailureAction

const createRemoveUserFromOrganizationInitAction =
  (): RemoveUserFromOrganizationInitAction => ({
    type: REMOVE_USER_FROM_ORGANIZATION_INIT_ACTION,
  })
const createRemoveUserFromOrganizationSuccessAction = (
  payload: RemoveUserFromOrganizationSuccessPayload,
): RemoveUserFromOrganizationSuccessAction => ({
  type: REMOVE_USER_FROM_ORGANIZATION_SUCCESS_ACTION,
  payload,
})
const createRemoveUserFromOrganizationFailureAction = (
  payload: RemoveUserFromOrganizationErrorPayload,
): RemoveUserFromOrganizationFailureAction => ({
  type: REMOVE_USER_FROM_ORGANIZATION_FAILURE_ACTION,
  payload,
})

export const removeUserFromOrganization = (
  userId: string,
  organizationId: string,
): ThunkAction<void, RootState, void, RemoveUserFromOrganizationActions> => {
  return (
    dispatch: ThunkDispatch<RootState, void, RemoveUserFromOrganizationActions>,
    getState: () => RootState,
  ): Promise<void> => {
    dispatch(createRemoveUserFromOrganizationInitAction())
    return axios
      .put<RemoveUserFromOrganizationSuccessPayload>(
        `/organizations/${organizationId}/deactivateuser`,
        { userId: userId },
        selectAuthedJsonApiRequestConfig(getState()),
      )
      .then(
        (response) => {
          dispatch(createRemoveUserFromOrganizationSuccessAction(response.data))
          dispatch(
            getOrgMembers(organizationId, {
              page: 0,
              perPage: 10,
              renderMetrics: true,
            }),
          )
          dispatch(closeModal())
          dispatch(
            createSetIsToastOpen(true, {
              toastMessage: (
                <RemoveUserFromOrganizationToastMessage
                  email={response.data.user.email}
                  firstName={response.data.user.firstName || ''}
                  lastName={response.data.user.lastName || ''}
                />
              ),
            }),
          )
        },
        (err) => {
          dispatch(
            createRemoveUserFromOrganizationFailureAction(err.response.data),
          )
        },
      )
  }
}
